export const patreonUrl = "https://www.patreon.com/kdk_ua/membership";
export const youtubeUrl = "https://www.youtube.com/@kdk/membership";

export const teams = {
  550: {
    shortName: "ШАХ",
    name: "Шахтар",
    isUPL: true,
    gift: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  572: {
    shortName: "ДИН",
    name: "Динамо",
    isUPL: true,
    gift: true,
    feedUrl: "https://www.youtube.com/@FootballHubUA/streams",
  },
  599: {
    shortName: "ЗОР",
    name: "Зоря",
    isUPL: true,
    feedUrl: "https://www.youtube.com/@FootballHubUA/streams",
  },
  1121: {
    shortName: "ВОР",
    name: "Ворскла",
    isUPL: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3615: {
    shortName: "ЧОР",
    name: "Чорноморець",
    isUPL: true,
    gift: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3618: {
    shortName: "ЛЬВ",
    name: "Львів",
  },
  3619: {
    shortName: "ОЛЕ",
    name: "Олександрія",
    isUPL: true,
    gift: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3623: {
    shortName: "ДНІ",
    name: "Дніпро-1",
    isUPL: true,
    feedUrl: "https://www.youtube.com/@FootballHubUA/streams",
  },
  3625: {
    shortName: "ІНГ",
    name: "Інгулець",
  },
  3627: {
    shortName: "КОЛ",
    name: "Колос",
    isUPL: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3628: {
    shortName: "МЕТ",
    name: "Металіст 1925",
    isUPL: true,
    gift: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3632: {
    shortName: "РУХ",
    name: "Рух",
    isUPL: true,
    gift: true,
    feedUrl: "https://www.youtube.com/@upltv2023/streams",
  },
  4658: {
    shortName: "МИН",
    name: "Минай",
    isUPL: true,
    gift: true,
    feedUrl: "https://www.youtube.com/@upltv2023/streams",
  },
  6489: {
    shortName: "КРИ",
    name: "Кривбас",
    isUPL: true,
    gift: true,
    feedUrl: "https://www.youtube.com/@fckryvbas/streams",
  },
  6501: {
    shortName: "ВЕР",
    name: "Верес",
    isUPL: true,
    gift: true,
    feedUrl: "https://www.youtube.com/@veresclub1957/streams",
  },
  14437: {
    shortName: "МЕТ",
    name: "Металіст",
  },
  17161: {
    shortName: "ЛНЗ",
    name: "ЛНЗ",
    isUPL: true,
    gift: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  6496: {
    shortName: "ПОЛ",
    name: "Полісся",
    isUPL: true,
    gift: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3630: {
    shortName: "ОБО",
    name: "Оболонь",
    isUPL: true,
    feedUrl: "https://megogo.net/ua/menu/football/upl",
  },
  3617: {
    shortName: "КАР",
    name: "Карпати",
    gift: true,
  },
  3620: {
    shortName: "АГР",
    name: "Агробізнес",
  },
  3624: {
    shortName: "ГІР",
    name: "Гірник-Спорт",
  },
  3631: {
    shortName: "ПРИ",
    name: "Прикарпаття",
  },
  4657: {
    shortName: "КРЕ",
    name: "Кремінь",
  },
  5627: {
    shortName: "МЗ",
    name: "Металург З",
  },
  6486: {
    shortName: "БУК",
    name: "Буковина",
  },
  6487: {
    shortName: "ДІН",
    name: "Діназ",
  },
  6493: {
    shortName: "НИВ",
    name: "Нива Т",
  },
  6495: {
    shortName: "ПОД",
    name: "Поділля",
  },
  14433: {
    shortName: "ЧЕР",
    name: "Чернігів",
  },
  14434: {
    shortName: "ЕПІ",
    name: "Епіцентр",
  },
  21203: {
    shortName: "ХУС",
    name: "Хуст",
  },
  21319: {
    shortName: "НИВ",
    name: "Нива Б",
  },
  3616: {
    shortName: "ДЕС",
    name: "Десна",
  },
  2252: {
    shortName: "МАР",
    name: "Маріуполь",
  },
};

export const getUplTeams = () => {
  return Array.from(Object.keys(teams)).filter((id) => teams[id].isUPL);
};

export const ALL_POSITIONS = "All";
export const GOALKEEPER = "Goalkeeper";
export const DEFENDER = "Defender";
export const MIDFIELDER = "Midfielder";
export const ATTACKER = "Attacker";

export const positionKeysMap = {
  [GOALKEEPER]: "GK",
  [DEFENDER]: "D",
  [MIDFIELDER]: "MD",
  [ATTACKER]: "ST",
};

export const ALL_MONEY = 100;
export const ALL_PLAYERS = 15;
export const ALL_DEFENDERS = 5;
export const ALL_MIDFIELDERS = 5;
export const ALL_ATTACKERS = 3;
export const tgLink = "https://t.me/+VHBlTupWofg1Njgy";
